(() => {
  'use strict';
  if (customElements.get('journey-room-scene')) return;
  const loadImage = src => new Promise((resolve,reject) => {
    const img = new Image(); img.crossOrigin='anonymous'; img.onload=()=>resolve(img); img.onerror=reject; img.src=src;
  });
  const sizeOf = value => {
    const m=String(value).match(/(\d+(?:\.\d+)?)(?:\s+(\d+)\/(\d+))?\s*[×x]\s*(\d+(?:\.\d+)?)(?:\s+(\d+)\/(\d+))?/i);
    return m ? {width:Number(m[1])+(m[2]?Number(m[2])/Number(m[3]):0),height:Number(m[4])+(m[5]?Number(m[5])/Number(m[6]):0)} : null;
  };
  class JourneyRoomScene extends HTMLElement {
    connectedCallback() {
      if(this.started)return; this.started=true;
      this.root=this.closest('.thb-product-detail');
      this.selector=this.root?.querySelector('variant-selects');
      const reviews=this.root?.querySelector('.journey-review-rating');
      if(reviews)this.root.querySelector('.product-price-container')?.after(reviews);
      const price=this.root?.querySelector('.product-price-container');
      if(this.dataset.bestseller==='true'&&price&&!price.querySelector('.journey-bestseller')){
        const badge=document.createElement('span');
        badge.className='journey-bestseller';
        badge.textContent='Best Seller';
        price.querySelector('[id^="price-"]')?.after(badge);
      }
      if(!this.selector)return;
      this.variants=JSON.parse(this.selector.querySelector('script[type="application/json"]').textContent).map(v=>({...v,nativeOptions:v.options,option1:v.options[Number(this.dataset.sizeIndex||0)],option2:v.options[Number(this.dataset.finishIndex||1)]}));
      this.messages=JSON.parse(this.querySelector('[data-room-messages]').textContent);
      this.canvas=this.querySelector('canvas');this.cache=new Map();
      this.abort=new AbortController();
      this.buildOptions();
      const listen=(el,type,fn)=>el.addEventListener(type,fn,{signal:this.abort.signal});
      this.left=this.root.querySelector('.row > .columns:not(.product-information)');
      this.caption=this.querySelector('[data-room-caption]').content.cloneNode(true);
      this.left.append(this.caption);this.caption=this.left.querySelector('.journey-room-caption');
      this.buildRoomControls();
      const title=this.root.querySelector('.product-title-container');
      const intro=this.querySelector('[data-room-intro]').content.cloneNode(true);
      title.prepend(intro.querySelector('.journey-room-eyebrow'));
      title.querySelector('h1').after(intro.querySelector('.journey-room-meaning'));
      // The existing theme owns prices, inventory, URLs, and cart submissions.
      listen(document,'product:variant-change',event=>{
        if(String(event.detail.sectionId)===this.dataset.section)this.select(event.detail.variant);
      });
      const dialog=this.querySelector('dialog'),detail=this.caption.querySelector('[data-room-detail]');
      listen(detail,'click',()=>{if(this.art){dialog.showModal();dialog.querySelector('button').focus();}});
      listen(dialog.querySelector('[data-room-close]'),'click',()=>dialog.close());
      listen(dialog,'click',event=>{if(event.target===dialog)dialog.close();});
      listen(dialog,'close',()=>detail.focus({preventScroll:true}));
      this.resize=new ResizeObserver(()=>this.draw());this.resize.observe(this);
      this.initialize();
    }
    async initialize() {
      const initialVariant=this.variants.find(v=>String(v.id)===this.dataset.initialVariant)||this.variants[0];
      // Keep the native gallery stable when no variant preview exists.
      if(!initialVariant?.featured_image?.src){await this.select(initialVariant);return;}
      this.root.prepend(this);
      this.root.classList.add('journey-immersive');
      document.body.classList.add('journey-room-page');
      try {
        await this.changeRoom(this.rooms[0]);
        await this.select(initialVariant);
        if(!this.art)throw new Error('Artwork unavailable');
        this.draw();
      } catch {
        this.root.classList.remove('journey-immersive');
        document.body.classList.remove('journey-room-page');
        /* Restore the original product gallery when room images cannot load. */
      }
    }
    async select(variant) {
      variant=this.variants.find(v=>String(v.id)===String(variant?.id));
      const token=this.token=Symbol();this.variant=variant;this.art=null;
      this.updateOptions(variant);
      const status=this.caption.querySelector('[data-room-status]');
      this.caption.querySelector('[data-room-detail]').disabled=true;
      this.caption.querySelector('[data-room-selection]').textContent=variant?`${variant.option1}″ · ${variant.option2}`:'';
      status.textContent=variant?this.messages.loading:this.messages.unavailable;this.draw();
      if(!variant)return;
      try {
        const src=variant.featured_image?.src;
        if(!src)throw Error('No image');
        if(!this.cache.has(src))this.cache.set(src,loadImage(src).catch(error=>{this.cache.delete(src);throw error;}));
        const art=await this.cache.get(src);
        if(token!==this.token)return;
        this.art=art;status.textContent='';this.caption.querySelector('[data-room-detail]').disabled=false;
        const detail=this.querySelector('dialog img');detail.src=src;detail.alt=`${this.dataset.title} — ${variant.option1} — ${variant.option2}`;
        this.querySelector('[data-room-detail-caption]').textContent=`${variant.option1}″ · ${variant.option2}`;
        this.dataset.variant=String(variant.id);this.draw();
      } catch {if(token===this.token){status.textContent=this.messages.unavailable;this.draw();}}
    }
    buildRoomControls() {
      this.rooms=JSON.parse(this.querySelector('[data-room-options]').textContent);
      const dock=document.createElement('div');dock.className='journey-room-dock';
      this.left.append(dock);dock.append(this.caption);
      const rooms=document.createElement('div');rooms.className='journey-room-choices';rooms.setAttribute('role','group');rooms.setAttribute('aria-label','Room mockup');dock.append(rooms);
      for(const room of this.rooms){
        const b=document.createElement('button');b.type='button';b.dataset.roomKey=room.key;b.setAttribute('aria-label',room.name);
        const img=document.createElement('img');img.src=room.src;img.alt='';const label=document.createElement('span');label.textContent=room.name;b.append(img,label);
        b.addEventListener('click',()=>this.changeRoom(room));rooms.append(b);
      }
      const colors=document.createElement('details');colors.className='journey-wall-picker';
      colors.innerHTML='<summary><span class="journey-wall-chip"></span>Wall color</summary><div class="journey-wall-panel"><strong>Choose a wall color</strong><div class="journey-wall-swatches"></div><label>Custom color <input type="color" value="#efeee5" aria-label="Custom wall color"></label><button type="button" data-original-wall>Original wall</button><small>Paint colors are approximate on screen.</small></div>';
      dock.append(colors);
      const paints=[['White Dove','#efeee5'],['Simply White','#f6f6ed'],['Chantilly Lace','#f4f6f1'],['Pale Oak','#ddd9ce'],['Edgecomb Gray','#d9d3c4'],['Revere Pewter','#cbc6b8'],['October Mist','#b6b8a5'],['Vintage Vogue','#565d4f'],['Hale Navy','#434b56'],['Wrought Iron','#494a4b']];
      paints.forEach(([name,color])=>{const b=document.createElement('button');b.type='button';b.dataset.color=color;b.title=name;b.setAttribute('aria-label',name);b.style.background=color;b.addEventListener('click',()=>this.setWallColor(color));colors.querySelector('.journey-wall-swatches').append(b);});
      colors.querySelector('input').addEventListener('input',e=>this.setWallColor(e.target.value));
      colors.querySelector('[data-original-wall]').addEventListener('click',()=>this.setWallColor(null));
      colors.addEventListener('keydown',e=>{if(e.key==='Escape'){colors.open=false;colors.querySelector('summary').focus();}});
      this.dock=dock;
    }
    async changeRoom(room) {
      const token=this.roomToken=Symbol();
      try{
        const image=await loadImage(room.src);if(token!==this.roomToken)return;
        this.room=image;this.roomConfig=room;this.wallMask=null;this.paintedRoom=null;
        this.dock.querySelectorAll('[data-room-key]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.roomKey===room.key)));
        this.caption.querySelector('small').textContent=`Styled mockup · approximate room scale. Canvas dimensions shown; frames add to the outside size.`;
        this.setWallColor(this.wallColor||null);
      }catch{this.caption.querySelector('[data-room-status]').textContent='This room could not load. Please try again.';}
    }
    setWallColor(color) {
      this.wallColor=color;this.paintedRoom=null;
      this.dock.querySelector('.journey-wall-chip').style.background=color||'#e8e0cf';
      this.dock.querySelectorAll('[data-color]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.color===color)));
      if(color&&this.room&&window.StatementWalls){
        try{
          this.wallMask ||= window.StatementWalls.create(this.room,this.roomConfig.key,null,32).canvas;
          const layer=document.createElement('canvas');layer.width=this.room.width;layer.height=this.room.height;
          const c=layer.getContext('2d',{willReadFrequently:true});c.drawImage(this.room,0,0);
          const pixels=c.getImageData(0,0,layer.width,layer.height);
          const rgb=[1,3,5].map(start=>parseInt(color.slice(start,start+2),16));
          // Replace the wall's pigment, retaining neutral light and plaster texture.
          // Multiplication alone can darken beige but can never paint it white.
          for(let i=0;i<pixels.data.length;i+=4){
            const luminance=.2126*pixels.data[i]+.7152*pixels.data[i+1]+.0722*pixels.data[i+2];
            const light=Math.max(.72,Math.min(1.06,.97+(luminance-190)/255*.35));
            for(let channel=0;channel<3;channel++)pixels.data[i+channel]=Math.min(255,rgb[channel]*light);
          }
          c.putImageData(pixels,0,0);c.globalCompositeOperation='destination-in';c.drawImage(this.wallMask,0,0);
          this.paintedRoom=layer;
        }catch{this.caption.querySelector('[data-room-status]').textContent='Wall color preview is unavailable for this room.';}
      }
      this.draw();
    }
    buildOptions() {
      this.options=document.createElement('div');this.options.className='journey-options';
      this.options.innerHTML='<fieldset><legend>Canvas size · inches</legend><div class="journey-sizes"></div></fieldset><fieldset><legend>Choose your finish</legend><div class="journey-frames"></div><p class="journey-finish-name" aria-live="polite"></p></fieldset>';
      this.selector.after(this.options);
      for(const size of new Set(this.variants.map(v=>v.option1))){
        const b=document.createElement('button');b.type='button';b.dataset.size=size;b.textContent=size;
        b.addEventListener('click',()=>this.chooseVariant(this.variants.find(v=>v.option1===size&&v.option2===this.variant?.option2&&v.available)||this.variants.find(v=>v.option1===size&&v.available)));
        this.options.querySelector('.journey-sizes').append(b);
      }
      this.selector.classList.add('journey-native-options');
    }
    chooseVariant(variant) {
      if(!variant)return;
      const selects=this.selector.querySelectorAll('select');
      selects.forEach((select,index)=>{select.value=variant.nativeOptions[index];});
      selects[0].dispatchEvent(new Event('change',{bubbles:true}));
    }
    updateOptions(variant) {
      if(!variant||!this.options)return;
      this.options.querySelectorAll('[data-size]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.size===variant.option1));b.disabled=!this.variants.some(v=>v.option1===b.dataset.size&&v.available);});
      const grid=this.options.querySelector('.journey-frames');
      if(grid.dataset.size!==variant.option1){
        grid.dataset.size=variant.option1;
        grid.replaceChildren(...this.variants.filter(v=>v.option1===variant.option1).map(v=>{
          const b=document.createElement('button');b.type='button';b.dataset.variant=v.id;b.title=v.option2;b.setAttribute('aria-label',v.option2);b.disabled=!v.available;
          if(v.featured_image?.src){const img=document.createElement('img');img.src=v.featured_image.src;img.alt='';img.loading='lazy';b.append(img);}else b.textContent=v.option2;
          b.addEventListener('click',()=>this.chooseVariant(v));return b;
        }));
      }
      grid.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.variant===String(variant.id))));
      this.options.querySelector('.journey-finish-name').textContent=variant.option2;
    }
    draw() {
      if(!this.room||!this.root.classList.contains('journey-immersive'))return;
      const box=this.getBoundingClientRect(),w=box.width,h=box.height;if(!w||!h)return;
      const dpr=Math.min(window.devicePixelRatio||1,2),ctx=this.canvas.getContext('2d');
      this.canvas.width=Math.round(w*dpr);this.canvas.height=Math.round(h*dpr);ctx.scale(dpr,dpr);
      ctx.fillStyle='#1c2521';ctx.fillRect(0,0,w,h);
      const mobile=window.matchMedia('(max-width: 899px)').matches;
      const viewHeight=mobile?this.left.getBoundingClientRect().height:h;
      const config=this.roomConfig||{inches:108,fraction:1,y:.36};
      const pixelsPerInch=this.room.width*config.fraction/config.inches;
      // 108-inch modeled sofa reference, matching the Studio. One transform
      // moves/scales the room and the selected framed artwork together.
      let factor=mobile?Math.max(w/this.room.width,viewHeight/this.room.height,w/(pixelsPerInch*66)):h/this.room.height;
      if(mobile&&this.variant?.nativeOptions.length===3){
        const dimensions=this.variants.map(v=>sizeOf(v.option2)||sizeOf(v.option1)).filter(Boolean);
        factor=Math.min(factor,w*.88/(pixelsPerInch*Math.max(...dimensions.map(d=>d.width))),viewHeight*.72/(pixelsPerInch*Math.max(...dimensions.map(d=>d.height))));
      }
      const cx=mobile?w*.5:w*.31,cy=mobile?viewHeight*.43:h*.36;
      const x=cx-this.room.width*.5*factor,y=cy-this.room.height*config.y*factor;
      ctx.drawImage(this.room,x,y,this.room.width*factor,this.room.height*factor);
      if(this.paintedRoom)ctx.drawImage(this.paintedRoom,x,y,this.room.width*factor,this.room.height*factor);
      if(mobile){
        const end=y+this.room.height*factor;
        const fade=ctx.createLinearGradient(0,end-130,0,end);
        fade.addColorStop(0,'rgba(28,37,33,0)');fade.addColorStop(1,'#1c2521');
        ctx.fillStyle=fade;ctx.fillRect(0,end-130,w,130);
      }
      if(this.art&&this.variant){
        const d=sizeOf(this.variant.option2)||sizeOf(this.variant.option1);if(!d)return;
        const width=d.width*pixelsPerInch*factor,height=width*this.art.height/this.art.width;
        ctx.save();ctx.shadowColor='rgba(25,20,15,.32)';ctx.shadowBlur=6*factor;ctx.shadowOffsetX=2*factor;ctx.shadowOffsetY=4*factor;
        ctx.drawImage(this.art,cx-width/2,cy-height/2,width,height);ctx.restore();
        this.geometry={roomWidth:this.room.width*factor,artWidth:width,artHeight:height,x:cx-width/2,y:cy-height/2};
      }
      this.canvas.setAttribute('aria-label',`${this.dataset.title}, ${this.variant?.option1||''}, ${this.variant?.option2||''} — styled sofa room mockup`);
    }
  }
  customElements.define('journey-room-scene',JourneyRoomScene);
})();
